import OItemDetailsCompact from './o-item-details-compact';

export default OItemDetailsCompact;